<template>
  <div class='view-content w880'>
    <button class='close' @click="$emit('close')">
      <span class='blind'>팝업 닫기</span>
    </button>
    <div class='scroll-area com-scroll-y'>
      <span class='sub-title'>연장 수정</span>
      <div class='view-area'>
        <table class='com-table left'>
          <colgroup>
            <col style='width: 160px' />
            <col style='width: 600px' />
          </colgroup>
          <tbody>
          <tr>
            <th>회원명</th>
            <td>{{ ticketExpHistory.c_customer_nm }}</td>
          </tr>
          <tr>
            <th>이용권명</th>
            <td>
              {{ ticketExpHistory.c_prod_nm }}
            </td>
          </tr>
          <tr>
            <th>현재 유효기간</th>
            <td>{{ expireStartDate }}~{{ expireEndDate }}</td>
          </tr>
          <tr>
            <th>유형</th>
            <td>
              {{ ticketExpHistory.c_exp_plus_type_cd === 'H' ? '홀딩 (연장 기간동안 예약 및 입장 불가)' : '연기 (단순 기간연기)' }}
            </td>
          </tr>
          <tr>
            <th>연장기간 <span class='imp'>*</span></th>
            <td>
              <div class='line'>
                <single-calendar
                    ref='expirePlusStartDt'
                    :disabled='true'
                    :disabled-date-list='disabledDateList'
                    :start-date='editField.expirePlusStartDt'
                    @update='updateExpStartDt' />
                ~
                <single-calendar
                    ref='expirePlusEndDt'
                    :disabled-date-list='disabledDateList'
                    :end-date='editField.expirePlusEndDt'
                    @update='updateExpEndDt' />
              </div>
              <div class='line'>
                <input v-model='editField.expirePlusDay' class='center w60'
                       type='number'
                       @keyup='onInputExpPlusDay' />
                <span class='txt'>일</span>
              </div>
            </td>
          </tr>
          <tr>
            <th>변경 후 유효기간</th>
            <td>
              <span class='red'>{{ expireStartDate }} ~ {{ calExpEndDt }}</span>
            </td>
          </tr>
          <tr>
            <th>등록자 <span class='imp'>*</span></th>
            <td>
              <select-form :select-data='expPlusStaffList' :select-value='expPlusStaffValueList'
                           :selected-value='editField.expirePlusStaffId'
                           class='w120'
                           @update:set='(val) =>(editField.expirePlusStaffId = val)'
              ></select-form>
            </td>
          </tr>
          <tr>
            <th>연기 사유 <br/>({{ editField.expirePlusMemo.length | numberFormatFilter }} / {{MEMO_MAX_LEN | numberFormatFilter}})</th>
            <td>
              <textarea v-model='editField.expirePlusMemo' class='full' :maxlength="MEMO_MAX_LEN"></textarea>
            </td>
          </tr>
          </tbody>
        </table>
        <div class='bottom-btn'>
          <button class='com-btn' @click="$emit('close')">
            취소
          </button>
          <button v-if='!buttonDisabled' class='com-btn blue' @keydown.enter.prevent @click='onPostExtPeriod'>
            수정
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import {MixinAllowedMenu} from '@/assets/js/mixinAllowedMenu';
import {Utils} from '@/assets/js/utils';
import {pagingInfo} from '@/assets/js/common';

export default {
  name: 'PeriodEdit',
  mixins: [MixinAllowedMenu],
  props: {
    expPlusStaffList: '', // 상담자 이름 목록
    expPlusStaffValueList: '', // 상담자 값(id) 목록
    ticketExpHistory: null
  },
  computed: {
    // 유효기간 계산
    expireStartDate() {
      const {c_exp_start_dt, c_org_exp_start_dt} = this.ticketExpHistory;
      return moment(c_exp_start_dt || c_org_exp_start_dt).format('YYYY-MM-DD');
    },
    expireEndDate() {
      const {c_exp_end_dt, c_org_exp_end_dt} = this.ticketExpHistory;
      return moment(c_exp_end_dt || c_org_exp_end_dt).format('YYYY-MM-DD');
    },
    ticketType() {
      return this.ticketExpHistory.c_ticket_type_cd || '';
    },
    calExpEndDt() {
      // 변경 후 유효기간 종료일 계산
      return moment(this.expireEndDate).add(this.editField.expirePlusDay - this.ticketExpHistory.c_exp_plus_day, 'days').format('YYYY-MM-DD');
    },
  },
  data() {
    return {
      selectedContract: null,
      productIndex: 0,
      layerTab: 1,
      editField: {
        expirePlusType: '',
        expirePlusStartDt: '',
        expirePlusEndDt: '',
        expirePlusDay: '',
        expirePlusStaffId: '',
        expirePlusMemo: '',
      },
      periodPop: true,
      extPeriodList: [], // 연장 히스토리 내역
      disabledDateList: [], // 연장되는 기간들의 목록
      pagingInfo: {...pagingInfo},
      buttonDisabled: false,
    };
  },
  created() {
    this.MEMO_MAX_LEN = 1000;
  },
  mounted() {
    this.initExtentionEditField();
  },
  methods: {
    async initExtentionEditField() {
      const {c_staff_id, c_exp_plus_start_dt, c_exp_plus_end_dt, c_exp_plus_day, c_exp_plus_memo} = this.ticketExpHistory

      this.editField = {
        expirePlusType: 'N',
        expirePlusStartDt: moment(c_exp_plus_start_dt).format('YYYY-MM-DD'),
        expirePlusEndDt: moment(c_exp_plus_end_dt).format('YYYY-MM-DD'),
        expirePlusDay: c_exp_plus_day,
        expirePlusStaffId: c_staff_id,
        expirePlusMemo: c_exp_plus_memo,
      };
    },

    // 유효기간 연장 기간 시작일 변경시
    updateExpStartDt(date) {
      // 현재 유효기간 이내 여부 체크
      if (moment(date).isBefore(this.expireStartDate)) {
        alert('현재 유효기간 내에서 선택하세요.');
        this.editField.expirePlusStartDt = this.expirePlusStartDt;
      }
      // 연장 종료날짜보다 큰 경우
      else if (!Utils.isEmpty(this.editField.expirePlusEndDt) && moment(date).isAfter(this.editField.expirePlusEndDt)) {
        console.log('date', date);
        console.log('this.editField.expirePlusEndDt', this.editField.expirePlusEndDt);

        // alert("종료날짜보다 이후날짜를 선택할 수 없습니다...");
        // this.$refs.expirePlusStartDt.inputValue = this.editField.expirePlusEndDt;
        // this.$refs.expirePlusStartDt.setCalendarSelectedDate(this.editField.expirePlusEndDt);
        // this.editField.expirePlusStartDt = this.editField.expirePlusEndDt;

        this.editField.expirePlusStartDt = date;
        this.editField.expirePlusEndDt = date;

        this.$refs.expirePlusEndDt.inputValue = date;
        this.$refs.expirePlusEndDt.setCalendarSelectedDate(this.editField.expirePlusEndDt);
        this.editField.expirePlusEndDt = this.editField.expirePlusEndDt;
      } else {
        this.editField.expirePlusStartDt = date;
      }

      this.checkDuplicateExpireDate();
      this.calculateExpirePlusDay();
    },

    // 유효기간 연장 기간 종료일 변경시
    updateExpEndDt(date) {
      if (moment(date).isBefore(this.expireStartDate)) {  // 현재 유효기간 이내 여부 체크
        alert('현재 유효기간 내에서 선택하세요.');
        this.editField.expirePlusEndDt = this.expirePlusStartDt;
      } else if (!Utils.isEmpty(this.editField.expirePlusStartDt) &&
          moment(date).isBefore(this.editField.expirePlusStartDt)) { // 연장 시작날짜보다 작은 경우
        alert("시작 날짜보다 이전 날짜를 선택할 수 없습니다.");
        this.$refs.expirePlusEndDt.setCalendarSelectedDate(this.editField.expirePlusStartDt);
        this.editField.expirePlusEndDt = this.editField.expirePlusStartDt;
      } else {
        this.editField.expirePlusEndDt = date;
      }

      this.checkDuplicateExpireDate();
      this.calculateExpirePlusDay();
    },

    checkDuplicateExpireDate() {
      this.buttonDisabled = false;
      if (!Utils.isEmpty(this.editField.expirePlusEndDt)) {
        const {expirePlusStartDt, expirePlusEndDt} = this.editField;
        for (const disabledDate of this.disabledDateList) {
          const {startDate, endDate} = disabledDate;

          if (moment(expirePlusStartDt).isBefore(startDate) && moment(expirePlusEndDt).isAfter(endDate)) {
            alert('연장 기간을 중복해서 신청할 수 없습니다.');
            this.buttonDisabled = true;
            break;
          }
        }
      }
    },

    // 연장 일수 입력시
    onInputExpPlusDay() {
      if (Utils.isEmpty(this.editField.expirePlusDay)) {
        return false;
      }

      if (this.editField.expirePlusDay < 1) {
        this.editField.expirePlusDay = 1;
      }

      const dFormat = 'YYYY-MM-DD';
      this.editField.expirePlusEndDt = moment(this.editField.expirePlusStartDt, dFormat).
          add(this.editField.expirePlusDay - 1, 'days').
          format(dFormat);
    },

    // 기간 연장 등록 버튼 클릭시
    async onPostExtPeriod() {
      try {
        await this.updateExtPeriod();

        alert('기간 연장이 수정되었습니다.');

        this.$emit('close');
      } catch (error) {
        console.log(error);
      }
    },

    // 센터회원 기간연장내역 수정
    updateExtPeriod() {
      const {c_center_id, c_center_contract_id} = this.ticketExpHistory

      const params = this.getModifyParams();
      return api.post(`/admin/api/center/${c_center_id}/contract/extend/${c_center_contract_id}`, params);
    },

    // 기간연장 수정 파라미터 가공
    getModifyParams() {
      const {
        expirePlusType,
        expirePlusStartDt,
        expirePlusEndDt,
        expirePlusDay,
        expirePlusStaffId,
        expirePlusMemo,
      } = this.editField;

      const params = {
        expirePlusType,
        expirePlusStartDt,
        expirePlusEndDt,
        expirePlusDay,
        expirePlusStaffId,
        expirePlusMemo,
      };

      return params;
    },

    calculateExpirePlusDay() {
      // 연장시작일자/연장종료일자로 연장일수 계산
      const {expirePlusStartDt, expirePlusEndDt} = this.editField;
      if (Utils.isEmpty(expirePlusStartDt) || Utils.isEmpty(expirePlusEndDt)) {
        return false;
      }

      const dFormat = 'YYYY-MM-DD';
      const diffDays = moment(expirePlusEndDt, dFormat).diff(moment(expirePlusStartDt, dFormat), 'days');

      this.editField.expirePlusDay = diffDays + 1;
    },
  },

};
</script>

<style scoped>
.view-content {
  max-height: 90vh;
  padding: 70px 0 45px;
}

.view-content .close {
  position: absolute;
  right: 35px;
  top: 20px;
  width: 20px;
  height: 20px;
  background: url('/img/icons/layerpop_square_close_btn.jpg') no-repeat 0 0;
}

.view-content .scroll-area {
  overflow: auto;
  max-height: 600px;
}

.sub-title {
  display: block;
  font-size: 20px;
  color: #000;
  margin-bottom: 24px;
}

.view-content .scroll-area {
  padding: 0 80px;
}
</style>
